<div class="revision-history">
  <div class="revision-history-header">
    <span class="revision-history-title">{{ 'EDITOR.REVISION_HISTORY.TITLE' | translate }}</span>
    <button type="button" class="revision-history-close" [attr.aria-label]="'EDITOR.REVISION_HISTORY.CLOSE' | translate" (click)="close.emit()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="revision-history-filter">
    <mat-slide-toggle [checked]="filterSystemOnly" (change)="onToggleFilter($event.checked)">
      {{ 'EDITOR.REVISION_HISTORY.SYSTEM_FILTER' | translate }}
    </mat-slide-toggle>
  </div>

  <div class="revision-history-list">
    @if (loading) {
      <div class="revision-history-empty">{{ 'EDITOR.REVISION_HISTORY.LOADING' | translate }}</div>
    } @else if (hasNoResults) {
      <div class="revision-history-empty">
        {{ (filterSystemOnly ? 'EDITOR.REVISION_HISTORY.NO_SYSTEM_RESULTS' : 'EDITOR.REVISION_HISTORY.NO_RESULTS') | translate }}
      </div>
    } @else {
      @for (group of groups; track group.day) {
        <div class="revision-history-group">
          <div class="revision-history-group-label">{{ group.day }}</div>
          <div class="revision-history-cards">
            @for (revision of group.revisions; track revision.id) {
              @let isDownloadable = canDownload && !revision.isCurrent;
              <div class="revision-card-wrapper">
                <button
                  type="button"
                  class="revision-card"
                  [class.is-downloadable]="isDownloadable"
                  [class.is-selected]="revision.isSelected"
                  [class.is-system]="revision.systemGenerated"
                  (click)="select.emit(revision.id)"
                >
                  <div class="revision-card-top">
                    <span class="revision-card-date">{{ revision.dateLabel }}</span>
                    @if (revision.isCurrent) {
                      <span class="revision-chip revision-chip-current">{{ 'EDITOR.REVISION_HISTORY.CURRENT' | translate }}</span>
                    }
                    @if (revision.systemGenerated) {
                      <span class="revision-chip revision-chip-ai">
                        <mat-icon>auto_awesome</mat-icon>
                        {{ 'EDITOR.REVISION_HISTORY.BRIEF_AI' | translate }}
                      </span>
                    }
                  </div>
                  <div class="revision-card-relative">{{ revision.relative }}</div>
                  <div class="revision-card-author">
                    <app-avatar [input]="revision.authorName" size="small"></app-avatar>
                    <span class="revision-card-author-name">{{ revision.authorName }}</span>
                    @if (revision.otherAuthorCount > 0) {
                      <span class="revision-card-author-others">{{
                        (revision.otherAuthorCount === 1 ? 'EDITOR.REVISION_HISTORY.OTHER_AUTHOR' : 'EDITOR.REVISION_HISTORY.OTHER_AUTHORS')
                          | translate: { count: revision.otherAuthorCount }
                      }}</span>
                    }
                    @if (revision.minutesVerboseness !== null) {
                      <span class="revision-chip revision-chip-detail">{{ 'MINUTES_STYLING.' + revision.minutesVerboseness | translate }}</span>
                    }
                  </div>
                </button>
                @if (isDownloadable) {
                  <button
                    type="button"
                    class="revision-card-download"
                    [matMenuTriggerFor]="downloadMenu"
                    [matTooltip]="'EDITOR.REVISION_HISTORY.DOWNLOAD' | translate"
                    [attr.aria-label]="'EDITOR.REVISION_HISTORY.DOWNLOAD' | translate"
                  >
                    <mat-icon>download</mat-icon>
                  </button>
                  <mat-menu #downloadMenu="matMenu">
                    <button mat-menu-item (click)="download.emit({ revisionId: revision.id, format: 'pdf' })">PDF</button>
                    <button mat-menu-item (click)="download.emit({ revisionId: revision.id, format: 'docx' })">DOCX</button>
                  </mat-menu>
                }
              </div>
            }
          </div>
        </div>
      }
    }
  </div>
</div>
